// Area mapping
// No two can have same stallId
//

import { HALL_KEYS_CONSTANT_DATA } from "./AreaOptionData";

// const Hall1_layoutData = [];
// const Hall2_layoutData = [];
const Hall3_layoutData = [
  {
    "hallId": 3,
    "stallId": "Stall3L_335A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_335B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_336",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_337",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_338",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_339",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_340",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_341",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_342",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_343",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_344",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_345",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_346",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_347A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_347B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_347C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_348A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_348B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_349A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_349B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_349C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_350A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_350B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_350C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_351A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3L_351B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_351C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_352A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_352AB",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_352B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_353A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_353B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_353C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_354A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_354B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_354C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_355",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_356A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_356B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_357A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3M_357B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_357C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_358A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_358B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_358C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_359A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_359B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_360A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_360B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_360C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_361A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_361B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_361C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_362A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_362B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_362C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_363A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_363B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3N_363C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_364A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_364B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_364C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_365A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_365B",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_366A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3P_366B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_366C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_367A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_367B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_369A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_369B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_369C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_369D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_369E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_369F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_370A",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_370B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_371A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_371B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_371C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_372A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Q_372B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_372C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_373A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_373B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_373C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_374A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_374B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3R_374C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_374D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_374E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_376A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_376B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_376C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_376D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_376E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_377A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3S_377B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_377C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_378A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_378B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_378C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_379A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_379B",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_380A",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_380B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_381A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_381B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_381C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3T_381D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_381E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_383A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_383B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_383C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_383D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_383E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_384A",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_384B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_385A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_385B",
    "section": "sectionData_9",
    "area": 36,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_386A",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3U_386B",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_386C",
    "section": "sectionData_9",
    "area": 18,
    "zone": "3B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor6",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_387A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_387B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_387C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_388A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_388B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_388C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_389A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_389B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_389C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_390A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_390B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_390C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_391A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_391B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_392A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_392B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3V_392C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_393A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_393B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_393C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_394A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_394B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_395A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_395B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_395C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_396A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_396B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_396C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_397A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_397B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_397D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_397C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_398A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_398B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3W_398C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_399A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_399B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_399C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_400A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_400B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_400C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_401A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_401B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_401C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_402A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_402B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_402C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_403A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_403B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_404A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_404B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3X_404C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_405A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_405B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_405C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_406A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_406B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_407A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_407B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_407C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_408",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_409A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_409B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_409C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_410A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_410B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Y_410C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_411A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_411B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_411C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_412A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_412B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_412C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_413A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_413B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_413C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_414A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_414B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_414C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_415A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_415B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_416A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_416B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3Z_416B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_417",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_418",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_419",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_420",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_421",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_422",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_423",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_424",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_425",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_426",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_427",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_428",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 3,
    "stallId": "Stall3AA_429",
    "section": "sectionData_2",
    "area": 9,
    "zone": "3A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor3",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  }
];
const Hall4_layoutData = [
  {
    "hallId": 4,
    "stallId": "Stall4A_1",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_2",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_3",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_4",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_5",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_6",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_7",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_8",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_9",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_10",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_11",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_12",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_13",
    "section": "sectionData_2",
    "area": 16,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_14",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_15",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_16",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_17",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_18",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_19",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_20",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_21",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_22",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_23",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_24",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_25",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_26",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_26A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_27",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_28",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_29",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_30",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_31",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_32",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_33A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_33B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34A",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34B",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_34C",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_34D",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34F",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34G",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_34J",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_34K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_34L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34M",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_34N",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_35A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_35B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_35C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_35D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_35E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_35F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_35G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_35H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_36A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_36B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_36C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_36D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_36E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_36F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_36H",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_37A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_37B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_37C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_37D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_37E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_38A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_38B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_38C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_38D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_38E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_38F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_38G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_39A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_39B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_39C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_39D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_40A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_40B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_40C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_40D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_40E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_41A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_41B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_41C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_41D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_42A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_42B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_42C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_42D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_43A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_43B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_43C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_43D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_44A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_44B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_44C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_44D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_45A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_45B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_45C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_45D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_46A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_46B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_46C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_47A",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_47B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_47C",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_48A",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_48B",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_49A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_49B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_49C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_49D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_50A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_50B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_50C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_50D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_51A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_51B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_51C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_52A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_52B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_52C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_53A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_53B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_53C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_54A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_54B",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_54C",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_55A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_55B",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_55C",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_56A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_56B",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_56C",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4A_57",
    "section": "sectionData_2",
    "area": 108,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "12x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_58A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_58B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_58C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_58D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_59A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_59B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_60A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_60B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_61",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_62",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_63A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_63B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_64A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_64B",
    "section": "sectionData_2",
    "area": 54,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_65A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_65B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_65C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_65D",
    "section": "sectionData_2",
    "area": 27,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_66A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_66B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_66C",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_66D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_67A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_67B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_67C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_68",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_69",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_70A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_70B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_70C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_71A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_71B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_71C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_71D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_72A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_72B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_72C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_73A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_73B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_74A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_74B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_74C",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_74D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_74E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_75",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_76A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_76B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_77A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_77B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_77C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_77D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_77E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_77F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_77G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_77H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_78A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_78B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_78C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_78D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_78E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_78F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_79A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_79B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_79C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_79D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_79E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_79F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80A",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80D",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80E",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_80F",
    "section": "sectionData_2",
    "area": 12,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_80H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_80J",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4B_80L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81J",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_81K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_81M",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_82A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_82B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_82C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_82D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_82E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_82F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_82G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_83A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_83AB",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_83B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_83C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_83D",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_84A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_84B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_84C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_84D",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_85A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_85B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_86A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_86B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_87A",
    "section": "sectionData_3",
    "area": 36,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_87B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_87C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_88A",
    "section": "sectionData_3",
    "area": 27,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_88B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_88C",
    "section": "sectionData_3",
    "area": 27,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_89A",
    "section": "sectionData_2",
    "area": 54,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "9x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_89B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_89C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_90A",
    "section": "sectionData_2",
    "area": 54,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_90B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_90C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_91A",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_91B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_91C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_92",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_93",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_94A",
    "section": "sectionData_1",
    "area": 54,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_94B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_95A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_95B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_95C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_95D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_95E",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_96A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_96B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_96C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_96D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_96E",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_97A",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_97B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_97C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_97D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_98A",
    "section": "sectionData_1",
    "area": 54,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_98B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_99",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_100",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_101A",
    "section": "sectionData_1",
    "area": 54,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_101B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_102A",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_102B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_102C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_102D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_102E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4C_103",
    "section": "sectionData_1",
    "area": 72,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "12x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_104A",
    "section": "sectionData_1",
    "area": 36,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_105A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_105B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_105C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_105D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_106A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_106B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_106C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_106D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_106E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_106F",
    "section": "sectionData_1",
    "area": 27,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_107A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_107B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_107C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_107D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_107E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_107F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_107G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_108A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_108B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_108C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_108D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_109A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_109B",
    "section": "sectionData_1",
    "area": 27,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_109C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_109D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_110A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_110B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_110C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_110D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_110E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_110F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_110G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_111A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_111B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_111C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_111D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_111E",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_112A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_112B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_112C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_112D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_112E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_112F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_112G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_113A",
    "section": "sectionData_1",
    "area": 27,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_113B",
    "section": "sectionData_1",
    "area": 27,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_114A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_114B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_114C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_114D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_114E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_114F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_114G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_114H",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_115A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_115B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_115C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_115D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_116A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_116B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_116C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_116D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_117A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_117B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_117C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_117D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_117E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_117F",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_118A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_118B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_118C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_118E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_118F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_119A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_119B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_119C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_120A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_120B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_120C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_120D",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_120E",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_120F",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_121A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_121B",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_121C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_121D",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_122A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_122B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_122C",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_122D",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_122E",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_123A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_123B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_123C",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_123D",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_123E",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_123F",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_124A",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_124B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_124C",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_124D",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_124E",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_124F",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_124G",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_125A",
    "section": "sectionData_3",
    "area": 18,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_125B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_125C",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_125D",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_125E",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_125F",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_125G",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_126A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_126B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_126C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_126D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_126E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_126F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_126G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_126H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127J",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_127K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4D_127M",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_128",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_129",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_130",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_131",
    "section": "sectionData_2",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_132",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_133",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_134",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_135",
    "section": "sectionData_3",
    "area": 12,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_136",
    "section": "sectionData_3",
    "area": 12,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_137A",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_137B",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_138",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_139",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_140",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_141",
    "section": "sectionData_3",
    "area": 9,
    "zone": "4C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_142A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_142B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_143",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_144",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_145",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_146",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_147",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_148",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_149",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_150",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_151",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_152",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_153",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_154",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_155",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_156",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_157",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_158",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_159",
    "section": "sectionData_1",
    "area": 16,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_160",
    "section": "sectionData_1",
    "area": 16,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 2
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_161",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_162",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_163",
    "section": "sectionData_1",
    "area": 12,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104H",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 4,
    "stallId": "Stall4E_104F",
    "section": "sectionData_1",
    "area": 18,
    "zone": "4D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor2",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  }
];
const Hall5_layoutData = [
  {
    "hallId": 5,
    "stallId": "Stall5F_164",
    "section": "sectionData_8",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_165",
    "section": "sectionData_8",
    "area": 16,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_166",
    "section": "sectionData_8",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_167",
    "section": "sectionData_8",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_168",
    "section": "sectionData_8",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_169",
    "section": "sectionData_8",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_170",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_171",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_172",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_173",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_174",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_175",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_176",
    "section": "sectionData_6",
    "area": 12,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_177",
    "section": "sectionData_4",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_178",
    "section": "sectionData_4",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_179",
    "section": "sectionData_4",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_180",
    "section": "sectionData_4",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_181",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_182",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_183",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_184",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_185",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_186",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_187",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_188",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_189",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_190",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_191",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_192",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_193",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_194",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_194A",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_195",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_196",
    "section": "sectionData_1",
    "area": 12,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x4",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_197",
    "section": "sectionData_12",
    "area": 27,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_198",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_199",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_200",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_201",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_202",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_203",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_204",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_205A",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_205B",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205E",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_205F",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_205G",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205H",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205J",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205K",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_205L",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_205N",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_206A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_206C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_206D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_206E",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_206F",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_206H",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_207A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_207C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_207D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_207E",
    "section": "sectionData_12",
    "area": 27,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_207H",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_208A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_208B",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_208C",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_208D",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_209A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_209B",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_209C",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_209D",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_210A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_210B",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_210C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_210D",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_210F",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_211A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_211B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_211C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_211D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_211E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_212A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_212B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_212C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_212D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_212E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_212F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_212G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_213A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_213B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_213C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_214A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_214B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_214C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_214D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_214E",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_215A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_215B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_215C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_215D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_215E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_215F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_216A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_216B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_216C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_216D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_216E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_216F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_216G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_216H",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_217A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_217B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_217C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_217D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_217E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_218A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_218B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_218C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_218D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_219A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_219B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_219C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_220A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_220B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_220C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_220D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_220E",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_221A",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_221B",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_221C",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_221D",
    "section": "sectionData_5",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_221E",
    "section": "sectionData_5",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_221F",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_221G",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_221H",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_222A",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_222B",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_222C",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_222D",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_223A",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_223B",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_223C",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_223D",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_223E",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_224A",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_224B",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_224C",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_224D",
    "section": "sectionData_6",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_224E",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_224F",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_224G",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_224H",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_225A",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_225B",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_225C",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_225D",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_225E",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_225F",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_225G",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_225H",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_226A",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_226B",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_226C",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_226D",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_226E",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_226F",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_226G",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_226H",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_227A",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_227B",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_227C",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_227D",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_227E",
    "section": "sectionData_8",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5F_227F",
    "section": "sectionData_8",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_229A",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_229B",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_229C",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_229D",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_229E",
    "section": "sectionData_10",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_229F",
    "section": "sectionData_10",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_230A",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_230B",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_230C",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_230D",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_230E",
    "section": "sectionData_10",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_230G",
    "section": "sectionData_10",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_230H",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_231A",
    "section": "sectionData_8",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_231B",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_231C",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_231D",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_231E",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_231F",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_231G",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_232A",
    "section": "sectionData_8",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_232B",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_232C",
    "section": "sectionData_8",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_233A",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_233B",
    "section": "sectionData_8",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_234A",
    "section": "sectionData_6",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_234B",
    "section": "sectionData_6",
    "area": 54,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "9x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_235A",
    "section": "sectionData_5",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_235C",
    "section": "sectionData_5",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_236A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_236B",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_236C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_236D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_237A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_237B",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_237C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_237D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_238A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_238B",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_238C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_238D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_239",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5A",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_240",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_241A",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_241B",
    "section": "sectionData_1",
    "area": 36,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_242A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_242B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_242C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_242D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_242E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_242F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_242G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_242H",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_243A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_243B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_243C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_243D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_243E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_243F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_244A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_244B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_244C",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_244D",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_244E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_244F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_244G",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_244H",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_245A",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_245B",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_245C",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_245D",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_245E",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_245F",
    "section": "sectionData_1",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_246A",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_246B",
    "section": "sectionData_1",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_247A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_247B",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_248A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_248B",
    "section": "sectionData_12",
    "area": 36,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_248C",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_249A",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_249C",
    "section": "sectionData_12",
    "area": 36,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_249G",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_250A",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_250B",
    "section": "sectionData_12",
    "area": 54,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "9x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_250G",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_251A",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251B",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_251D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_251E",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251F",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251G",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251H",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_251J",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5G_251K",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5B",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_252A",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_252B",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_252E",
    "section": "sectionData_12",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252G",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252H",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252J",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_252K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_252L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_252M",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_253A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_253B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_253C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_253D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_253E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_253F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_253G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_253H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_254A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_254B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_254C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_254D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_254E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_254F",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_255A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_255B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_255C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_255D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_255E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_255F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_255G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_256A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_256B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_257",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_258A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_258B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_258C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_258D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_258E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_258F",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_259A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_259B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_259C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_259D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_259E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_260A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_260B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_260C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_260D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_260E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_260F",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_261A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_261B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_261C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_261D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_261E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_262A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_262B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_263",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_264",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_265A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_265B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_266A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_266B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_267A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_267B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_267C",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_267D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_268A",
    "section": "sectionData_2",
    "area": 54,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_268B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_269",
    "section": "sectionData_2",
    "area": 72,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "12x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_270",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_271",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_272A",
    "section": "sectionData_2",
    "area": 54,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x9",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_272B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_273A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_273B",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5H_274",
    "section": "sectionData_2",
    "area": 72,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "PREMIUM",
    "size": "12x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_275A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_275B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_275C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_275D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_276A",
    "section": "sectionData_2",
    "area": 27,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_276B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_276C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_276D",
    "section": "sectionData_2",
    "area": 27,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_277A",
    "section": "sectionData_2",
    "area": 27,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_277B",
    "section": "sectionData_2",
    "area": 27,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_277C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_278A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_278B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_278C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_278D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_278E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_278F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_278H",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_279A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_279B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_279C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_279D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_280A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_280B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_280C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_280D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_281A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_281B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_281C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_281D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_282A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_282B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_282C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_282D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_283A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_283B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_283C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_283D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_283E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_283F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_284A",
    "section": "sectionData_2",
    "area": 27,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_284B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_284C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_284D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_285A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_285B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_285C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_286A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_286B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_286C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_287A",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_287B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_287C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_288A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_288B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_288C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_288D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_288E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_289A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_289B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_289C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_289D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_289E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_289F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_289G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_289H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_290A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_290B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "THREESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_290C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_291A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_291B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_291C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_291D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_292A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_292B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_292C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_292D",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_293A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_293B",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_293C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_293D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_293E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_293F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_294A",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_294B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_294C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_294D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_294E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_294F",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_295A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_295B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_295C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_295D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_295E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_295F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_295G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_295H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_296A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_296B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_296C",
    "section": "sectionData_2",
    "area": 18,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_296D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_296E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_296F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_296G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_297A",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_297B",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_297C",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_297D",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_297E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_297F",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_297G",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_297H",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298A",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298B",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298C",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298D",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298E",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298F",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298G",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298H",
    "section": "sectionData_12",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor7",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298J",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_298K",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298L",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_298M",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_299",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_300",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_301",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_302",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_303",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_304",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_305",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_306",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_306A",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_307",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_308",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_309",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_310",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5C",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_311",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_312",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_313",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor1",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_314",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_315",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_316",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_317",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_318",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_319",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_320",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_321",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_322",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_323",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 1
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_324",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_325",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_326",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_327",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_328",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_329",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_330",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_331",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_332",
    "section": "sectionData_2",
    "area": 16,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x4",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_333",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_334",
    "section": "sectionData_2",
    "area": 12,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5J_275F",
    "section": "sectionData_2",
    "area": 36,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0
  },
  {
    "hallId": 5,
    "stallId": "Stall5K_275E",
    "section": "sectionData_2",
    "area": 9,
    "zone": "5D",
    "venue": "BIEC",
    "stallDesign": "ONESIDE_OPENSTALL",
    "serviceProvider": "vendor4",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0
  }
];

export const HallLayoutData = {
  // [HALL_KEYS_CONSTANT_DATA.JWCC]: Hall_Jio_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h1]: Hall1_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h2]: Hall2_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h3]: Hall3_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h4]: Hall4_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h5]: Hall5_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h6]:  Hall6_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h7]: Hall7_layoutData,
};


export const LAYOUT_VENU = "NESCO"
